import { Types } from '@fiverr-private/theme';
import type { TabContextType } from '../types';
import { isSegmentedControlVariant } from '../helpers';

export const getStylingProps = (
    variant: TabContextType['variant'],
    placement: TabContextType['placement']
): Types.BoxType => ({
    display: 'flex',
    boxSizing: 'borderBox',
    ...(variant !== 'unstyled' && {
        position: 'relative',
        overflowY: 'auto',
    }),
    ...(isSegmentedControlVariant(variant) && {
        backgroundColor: 'grey_200',
        borderColor: 'border',
        borderWidth: 'sm',
        borderStyle: 'solid',
        outlineOffset: 'sm',
        padding: '2',
        borderRadius: variant === 'segmentedControlRounded' ? 'circle' : 'lg',
        gap: '2',
    }),
    ...(placement === 'left' || placement === 'right' ? { flexDirection: 'column' } : undefined),
});
